import { SelectOptionTypes } from "../../../components/Input";
import { AccountDetailsMin } from "../../../services";
import { AccountType } from "../types";
import { toIsoDate } from "../../../utils/dates";

export const ACCOUNT_TYPES = [
  { value: AccountType.ACCOUNT, label: AccountType.ACCOUNT },
  { value: AccountType.CASH, label: AccountType.CASH },
  { value: AccountType.OTHER, label: AccountType.OTHER },
];

export const ACCOUNT_TYPE_OPTIONS = ACCOUNT_TYPES.map((type) => ({
  label: type.label,
  value: type.value,
}));

// Types this form cannot create (e.g. Checking) appear only when editing a record of that type.
export const accountTypeOptionsFor = (accountType?: SelectOptionTypes) => {
  const isListed = ACCOUNT_TYPE_OPTIONS.some(
    (option) => option.value === accountType?.value,
  );
  if (!accountType || isListed) {
    return ACCOUNT_TYPE_OPTIONS;
  }
  return [...ACCOUNT_TYPE_OPTIONS, accountType];
};

export const FORM_ID = "account";

export const createDefaultAccount = (): AccountDetailsMin => ({
  name: "",
  institution: "",
  startDate: toIsoDate(new Date()),
  accountType: ACCOUNT_TYPES[0],
  initialBalance: "0",
  cashbackMode: "NONE",
  cashbackRate: "",
  cashbackMonthlyCap: "",
});
